import Popup from '../../components/Popup/Popup'
import Button from '../../components/Button/Button'
import { BUTTON_TYPES } from '../../components/Button'
import { BTN_TXT } from '../../constants'
import Typography from '../../components/Typography/Typography'
import { useAdditionalValuesPopup } from './Providers/AdditionalValuesPopupProvider'
import { useAdditionalValuesContext } from './Providers/AdditionalValuesContextProvider'
import { useCallback } from 'react'
import { setLoading } from '../../redux/store/common/slice'
import { notification } from '../../components/Notification'
import { deleteAdditionalValue } from '../Dashboard/api'
import { useDispatch } from 'react-redux'
import { TDeleteModalProps } from './types'

export const DeleteModal = ({ callback }: TDeleteModalProps) => {
  const dispatch = useDispatch()
  const { deleteAdditionalValuesPopup } = useAdditionalValuesPopup()
  const { selectedAdditionalValue } = useAdditionalValuesContext().state
  const { setSelectedAdditionalValue } = useAdditionalValuesContext().actions
  const { actions, state } = deleteAdditionalValuesPopup

  const onDelete = useCallback(async () => {
    if (!selectedAdditionalValue) return
    try {
      dispatch(setLoading(true))
      await deleteAdditionalValue({ uuid: selectedAdditionalValue.uuid })
      notification.success({
        message: `Additional value has been successfully removed.`
      })
      await callback()
      actions.close()
      setSelectedAdditionalValue(undefined)
    } catch (e) {
      console.error(e)
    } finally {
      dispatch(setLoading(false))
    }
  }, [
    actions,
    callback,
    dispatch,
    selectedAdditionalValue,
    setSelectedAdditionalValue
  ])

  return (
    <Popup
      {...state}
      width={442}
      footer={
        <>
          <Button type={BUTTON_TYPES.DEFAULT} onClick={actions.close} upperCase>
            {BTN_TXT.CANCEL}
          </Button>
          <Button
            type={BUTTON_TYPES.PRIMARY}
            onClick={onDelete}
            upperCase
            danger
          >
            {BTN_TXT.DELETE}
          </Button>
        </>
      }
    >
      <div className="column">
        <Typography.Body1>
          Additional value will be permanently deleted. Once deleted, it will be
          removed from the list. Do you want to proceed with deleting the
          Additional value?
        </Typography.Body1>
      </div>
    </Popup>
  )
}
